const enhanceProductUpdateFilter = () => {
  const filter = document.querySelector('[data-update-filter]')
  if (!filter) return

  const container = filter.parentElement
  const buttons = [...filter.querySelectorAll('button[data-product]')]
  const entries = [...container.querySelectorAll('h3[data-products]')].map(heading => {
    const nodes = [heading]
    let sibling = heading.nextElementSibling
    while (sibling && !sibling.matches('h2, h3')) {
      nodes.push(sibling)
      sibling = sibling.nextElementSibling
    }
    return { heading, nodes, products: heading.dataset.products.split(' ') }
  })
  const years = [...container.querySelectorAll('h2')].map(heading => {
    const headings = []
    let sibling = heading.nextElementSibling
    while (sibling && !sibling.matches('h2')) {
      if (sibling.matches('h3[data-products]')) headings.push(sibling)
      sibling = sibling.nextElementSibling
    }
    return { heading, headings }
  })

  const linkedEntryForHash = url => {
    let target
    try {
      target = document.getElementById(decodeURIComponent(url.hash.slice(1)))
    } catch {
      target = null
    }
    return entries.find(entry => entry.nodes.some(node => node === target || node.contains(target)))
  }

  const apply = (requested, { honorHash = false } = {}) => {
    let product = buttons.some(button => button.dataset.product === requested) ? requested : ''
    const url = new URL(window.location.href)
    const linkedEntry = url.hash ? linkedEntryForHash(url) : null
    if (product && linkedEntry && !linkedEntry.products.includes(product)) {
      if (honorHash) product = ''
      else url.hash = ''
    }

    entries.forEach(entry => {
      const hidden = Boolean(product && !entry.products.includes(product))
      entry.nodes.forEach(node => { node.hidden = hidden })
    })
    years.forEach(year => { year.heading.hidden = year.headings.every(heading => heading.hidden) })
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.product === product)))

    if (product) url.searchParams.set('product', product)
    else url.searchParams.delete('product')
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url)
  }

  const applyLocation = () => apply(new URL(window.location.href).searchParams.get('product'), { honorHash: true })
  buttons.forEach(button => button.addEventListener('click', () => apply(button.dataset.product)))
  window.addEventListener('popstate', applyLocation)
  window.addEventListener('hashchange', applyLocation)
  applyLocation()
  filter.hidden = false
}

document.addEventListener('DOMContentLoaded', enhanceProductUpdateFilter)
